import { Location } from "../models/location";
import { LocationHierarchy } from "../models/location-hierarchy";
import { IApplicationUser, ApplicationUser } from "../models/application-user";
import { MeasurementViewModel } from "../models/measurement-view-model";

export interface IState {
	applicationUser: IApplicationUser;
	locationState: LocationState;
}

export class LocationState {
	locations: Location[] = new Array<Location>();
	selectedLocations: Location[] = new Array<Location>();

	initialized: boolean = false;
	version: number = 0;

	// refactored: Current Measurements
	currentLocation: Location;

	getSelectedLocation(): Location {
		return this.selectedLocations[0];
	}

	selectAllLocations() {
		this.clearSelectedLocations();
		for (let i = 0; i < this.locations.length; i++) {
			this.selectedLocations[i] = this.locations[i];
		}
	}

	clearSelectedLocations() {
		this.selectedLocations = new Array<Location>();
	}
}

export const initialState: IState = {
	applicationUser: new ApplicationUser(),
	locationState: new LocationState(),
};
